// A tapped push notification has to land on the exact order or conversation.
//
// The admin worker (public/admin-sw.js) focuses an open admin window and calls
// navigate() on it. That only works on a window the worker CONTROLS — and the
// dashboard, /admin, sits outside the worker's /admin/ scope. For that window
// the worker posts this message instead, and the page opens the link itself.

/** ⚠️ Same string as NAVIGATE_MESSAGE in public/admin-sw.js. */
export const SW_NAVIGATE_MESSAGE = 'storiz:navigate';

interface ContainerLike extends EventTarget {
  startMessages?: () => void;
}

/** Listen on `navigator.serviceWorker`; `go` gets a same-origin path. Returns the cleanup. */
export function listenForSwNavigate(
  container: ContainerLike | undefined,
  origin: string,
  go: (path: string) => void,
): () => void {
  if (!container) return () => {};
  const onMessage = (e: Event) => {
    const data = (e as MessageEvent).data as { type?: unknown; url?: unknown } | null;
    if (!data || typeof data !== 'object' || data.type !== SW_NAVIGATE_MESSAGE || typeof data.url !== 'string') return;
    let u: URL;
    try { u = new URL(data.url, origin); } catch { return; }
    if (u.origin !== origin) return;
    go(u.pathname + u.search + u.hash);
  };
  container.addEventListener('message', onMessage);
  // Messages sent to a page wait in a queue until it is started.
  container.startMessages?.();
  return () => container.removeEventListener('message', onMessage);
}
